import "D:\\Projects\\NET2\\UJP\\Ostalo\\PorocevalskiPortal\\PorocevalskiPortalApp\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\Projects\\NET2\\UJP\\Ostalo\\PorocevalskiPortal\\PorocevalskiPortalApp\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\Projects\\NET2\\UJP\\Ostalo\\PorocevalskiPortal\\PorocevalskiPortalApp\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\Projects\\NET2\\UJP\\Ostalo\\PorocevalskiPortal\\PorocevalskiPortalApp\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import 'spectre.css/dist/spectre.min.css';
import App from './App.vue';
import router from './router';
import store from './store';
import { createApp } from 'vue';
import { apiSymbol, createApi } from './lib/api';

require('popper.js');

import tippy from 'tippy.js';
import mitt from 'mitt';
var api = createApi(store);
router.beforeEach(function (to, from, next) {
  var _window$location$href;

  to.meta.requestUrl = (_window$location$href = window.location.href) !== null && _window$location$href !== void 0 ? _window$location$href : '';
  store.commit('appErrors', []);
  var usr = store.state.user;

  if (to.meta.auth) {
    if (!(usr !== null && usr !== void 0 && usr.id)) {
      next({
        name: 'index'
      });
      return;
    } else {
      if (usr.changePassword && to.name !== 'userProfile') {
        next({
          name: 'userProfile'
        });
      } else {
        if (to.meta.report) {
          if (usr !== null && usr !== void 0 && usr.isB2b) {
            next({
              name: 'reportList'
            });
            return;
          }
        }

        if (to.meta.superadmin) {
          if (!(usr !== null && usr !== void 0 && usr.superAdmin)) {
            next({
              name: 'reportList'
            });
            return;
          } else {
            next();
          }
        } else if (to.meta.admin) {
          if (!(usr !== null && usr !== void 0 && usr.admin)) {
            next({
              name: 'reportList'
            });
            return;
          } else {
            next();
          }
        } else {
          next();
        }
      }
    }
  } else {
    next();
  }
});
/* eslint-disable no-extend-native */

Date.prototype.toJSON = function () {
  return "".concat(this.getFullYear(), "-").concat((this.getMonth() + 1).toString().padStart(2, '0'), "-").concat(this.getDate().toString().padStart(2, '0'), "T").concat(this.getHours().toString().padStart(2, '0'), ":").concat(this.getMinutes().toString().padStart(2, '0'), ":").concat(this.getSeconds().toString().padStart(2, '0'), ".").concat(this.getMilliseconds().toString().padStart(3, '0'), "Z");
};

var app = createApp(App).use(router).use(store).provide(apiSymbol, api);
app.config.globalProperties.emitter = mitt();
app.mixin({
  computed: {
    $user: function $user() {
      return store.state.user;
    },
    $appData: function $appData() {
      return store.state.appData;
    },
    $appLoading: function $appLoading() {
      return store.state.appLoading;
    },
    $appErrors: function $appErrors() {
      return store.state.appErrors;
    }
  }
});
app.directive('tooltip', {
  beforeMount: function beforeMount(el, binding, vnode) {
    tippy(el, {
      content: binding.value,
      placement: 'top',
      allowHTML: true,
      onShow: function onShow(instance) {
        instance.setContent(el.getAttribute('data-tippy-content'));
      }
    });
  }
});
app.directive('focus', {
  mounted: function mounted(el) {
    el.focus();
  }
});
app.mount('#app');